<template>
  <div
    class="step"
    :class="{
      current: props.step === props.currentStep,
      done: props.step < props.currentStep
    }"
  >
    <div class="title" v-html="props.stepTitle"></div>
  </div>
</template>

<script setup>
const props = defineProps({
  step: Number,
  currentStep: Number,
  stepTitle: String,
  stepDescription: String
})
</script>

<style lang="scss" scoped>
.step {
  padding-top: 2px;
  padding-left: 25px;
  position: relative;
  display: inline-block;

  &.current {
    background: url(/images/loading.gif) no-repeat left top;
    background-size: 20px 20px;
  }

  &.done {
    &::before {
      content: '';
      width: 20px;
      height: 20px;
      background: url(/images/tick.svg) no-repeat center center var(--CTA);
      border-radius: 50%;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
}

.title {
  font-size: 1.6rem;

  letter-spacing: 0.16px;
}

.text {
  overflow: 0.75;
  font-size: 1.5rem;
  letter-spacing: 0.15px;
  line-height: 140%;
}
</style>
